export const GameMode = Object.freeze({
  ASKER : Symbol(0),
  ANSWERER : Symbol(1),
})